import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import HoverImage from 'react-hover-image/build';
import ReactStrapTable from 'components/reactStrapTable';
import AddContractModal from '../AddContract';
import { cloneDeep } from 'lodash';
import { ModuleAccess } from 'utils/moduleaccess';
import Add from 'assets/icon/Add-White-Icon.svg'
import useAxios from 'hooks/useAxios';
import Drawer from 'components/Drawer';
import commonColumns, { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';


let tableDataBackup = [];

const ContractTable = (props) => {
  const {
    data,
    loading,
    totalSize,
    onPageChange,
    filters,
    onSearchColumnFilters = () => '',
    onExport,
    thirdPartyAdmin,
    enableAdd,
    refetch,
    toggleSider,
    collapseSider,
  } = props;
  const API = useAxios();
  tableDataBackup = data;
  const navigate = useNavigate();
  const [tableData, setTableData] = useState(tableDataBackup);
  const [reset, setReset] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { thirdPartyAdminID, tenantID } = thirdPartyAdmin;
  const [addState, updateAddState] = useState({
    addContractModal: false,
  });
  const [hasExportPermission, setHasExportPermission] = useState(false);

  const setState = (obj) => updateAddState((pre) => ({ ...pre, ...obj }));

  const onToggleAddContractModal = () => {
    refetch();
    setState({
      addContractModal: !addState.addContractModal,
    });
  };
  const { addContractModal } = addState;

  useEffect(() => {
    setTableData(data);
    tableDataBackup = data;
  }, [data]);

  useEffect(() => {
    setHasExportPermission(ModuleAccess("CON", "EXP"));
  }, []);

  let mainCol = [
    {
      dataField: 'options',
      text: 'Options',
      width: 100,
      show: true,
      hideColFilter: true,
      action: true
    },
    {
      dataField: 'tpaName',
      text: 'TPA',
      width: 144,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      hideColFilter: true,
    },
    {
      dataField: 'coveredEntityName',
      text: 'Covered Entity',
      width: 300,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      hideColFilter: true,
    },
    // {
    //   dataField: 'opaCode',
    //   text: '340B ID',
    //   width: 144,
    //   show: true,
    //   inputType: 'text',
    //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //   hideColFilter: true,
    // },
    {
      dataField: 'pharmacyName',
      text: 'Pharmacy',
      width: 288,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      hideColFilter: true,
    },
    {
      dataField: 'npi',
      text: 'Pharmacy NPI',
      width: 144,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      hideColFilter: true,
    },
    {
      dataField: 'contractStatus',
      text: 'Contract Status',
      width: 144,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      hideColFilter: true,
    },
    {
      dataField: 'effectiveStartDate',
      text: 'Contract Start Date',
      sort: true,
      width: 144,
      show: true,
      inputType: 'date',
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
    },
    {
      dataField: 'effectiveEndDate',
      text: 'Contract End Date',
      sort: true,
      width: 144,
      show: true,
      inputType: 'date',
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
    },
    // {
    //   dataField: 'retailDispenseFees',
    //   text: 'Retail Dispense Fee',
    //   width: 144,
    //   show: true,
    //   inputType: 'text',
    //   cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
    //   hideColFilter: true,
    // },
    // {
    //   dataField: 'specialtyDispenseFees',
    //   text: 'Specialty Dispense Fee',
    //   width: 144,
    //   show: true,
    //   inputType: 'text',
    //   cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
    //   hideColFilter: true,
    // },
    {
      dataField: 'dispenseFees',
      text: 'Cash Dispense Fee',
      width: 144,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
      hideColFilter: true,
    },
    {
      dataField: 'wholesaler',
      text: 'Wholesaler Name',
      width: 144,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      hideColFilter: true,
    },
    {
      dataField: 'wholesalerAccount',
      text: '340B Account #',
      width: 144,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      hideColFilter: true,
    },
    {
      dataField: 'orderingStatus',
      text: 'Ordering Status',
      width: 144,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      hideColFilter: true,
    },
    {
      dataField: 'orderingStartDate',
      text: 'Ordering Start Date',
      width: 144,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
      hideColFilter: true,
    },
  ]

  const onHandleSort = (filter, hasColFilter) => {
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };

  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
    }
  };
  const hasPermission = (code) => {
    return ModuleAccess("CON", code);

  }

  const handleFilterCancel = () => {
    refetch();
  };
  return (
    <div>
        <h5 className="f-16 text-primary font-weight-700">
      Contract Count ({totalSize})
    </h5>
    <hr />
    <div
      className='table-card scroll-table position-relative border-0 rounded pt-0'
      fixed-height={tableData.length > 0 ? 'fixed-height' : 'default'}
    >
      <ReactStrapTable
        id='contract-table'
        height={550}
        loading={loading}
        fixedColumn
        width={1200}
        reset={reset}
        hasPagination
        data={tableData}
        columns={mainCol}
        onExport={onExport}
        filters={filters}
        totalRecords={totalSize}
        pageSize={filters.pageSize}
        currentPage={filters.currentPage}
        handleSort={onHandleSort}
        onPageChange={onHandlePageChange}
        onPageSizeChange={onPageSizeChange}
        onFilterCancel={handleFilterCancel}
        onSearchColumnFilters={handleSearchColumnFilters}
        hasExportPermission={hasExportPermission}
        collapseSider={collapseSider}
        enabletogglesider={true}
        toggleSider={toggleSider}
      >
        {/* <Button onClick={onToggleAddContractModal} disabled={enableAdd} color='primary' className='search' size='sm' hidden={!hasPermission('ADD')} >
          <span className="right_5">
            <img src={Add} alt="" />
          </span>{" "}

          Add
        </Button>
        <AddContractModal isOpen={addContractModal} thirdPartyAdmin={thirdPartyAdmin} toggle={onToggleAddContractModal} /> */}
        {/* <div className='mx-4 text-light f-0 text-white font-weight-lighter border-end'>
          |
        </div> */}
      </ReactStrapTable>

    </div>
    </div>
  );
};
export default ContractTable;
